import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { publique } from '../services/api';
import Coquille, { messagePublic } from './Coquille';

// Formulaire de consentement : une page, cases décochées, mention générale,
// confirmation avec lien preuve et lien de retrait.
export default function Formulaire() {
  const { token } = useParams();
  const [f, setF] = useState(null);
  const [erreur, setErreur] = useState('');
  const [retrait, setRetrait] = useState('');
  const [choix, setChoix] = useState({});
  const [envoi, setEnvoi] = useState(false);
  const [resultat, setResultat] = useState(null);

  useEffect(() => {
    publique.formulaire(token).then((r) => setF(r.data)).catch((e) => {
      setErreur(messagePublic(e));
      if (e?.response?.data?.retrait) setRetrait(e.response.data.retrait);
    });
  }, [token]);

  const envoyer = async (e) => {
    e.preventDefault(); setEnvoi(true); setErreur('');
    try { setResultat((await publique.repondre(token, choix)).data); } catch (e2) { setErreur(messagePublic(e2)); }
    setEnvoi(false);
  };

  if (erreur && !f) {
    return (
      <Coquille>
        <h1>Lien indisponible</h1>
        <div className="pb-erreur">{erreur}</div>
        {retrait && <a className="pb-btn pb-btn--secondaire" style={{ textAlign: 'center', textDecoration: 'none' }} href={retrait}>Changer d'avis</a>}
      </Coquille>
    );
  }
  if (!f) return <Coquille><p>Chargement…</p></Coquille>;

  if (resultat) {
    const oui = Object.values(resultat.choix).filter(Boolean).length;
    return (
      <Coquille societe={f.societe.raison_sociale} marque={f.societe.marque}>
        <h1>Merci, vos choix sont enregistrés</h1>
        <div className="pb-succes">{oui === 0 ? 'Vous n\'avez accordé aucun consentement : nous ne vous contacterons pas pour nos offres.' : `${oui} accord${oui > 1 ? 's' : ''} enregistré${oui > 1 ? 's' : ''}, valable${oui > 1 ? 's' : ''} pour la durée indiquée.`}</div>
        <ul className="pb-recap">
          {f.cases.map((c) => (
            <li key={c.code}><span>{c.libelle}</span><span className={`pb-tag ${resultat.choix[c.code] ? 'pb-tag--oui' : 'pb-tag--non'}`}>{resultat.choix[c.code] ? 'Oui' : 'Non'}</span></li>
          ))}
        </ul>
        <a className="pb-btn" style={{ textAlign: 'center', textDecoration: 'none' }} href={`/p/${resultat.token_preuve}`}>Consulter ma preuve</a>
        <a className="pb-btn pb-btn--secondaire" style={{ textAlign: 'center', textDecoration: 'none' }} href={`/r/${resultat.token_retrait}`}>Changer d'avis</a>
        <p className="pb-note">Une confirmation vous est envoyée par {f.identifiant.includes('@') ? 'e-mail' : 'SMS'}. Vous pouvez retirer votre accord à tout moment, gratuitement, par ce lien, par STOP ou en contactant {f.societe.dpo_email || 'la société'}.</p>
        <p className="pb-hash">Empreinte de la preuve : {resultat.sha256}</p>
      </Coquille>
    );
  }

  return (
    <Coquille societe={f.societe.raison_sociale} marque={f.societe.marque}>
      <h1>Vos préférences de contact</h1>
      <p>Pour <span className="pb-identifiant">{f.identifiant}</span>. Depuis le 11 août 2026, nous devons disposer de votre accord explicite pour vous contacter au sujet de nos offres. Cochez uniquement ce que vous acceptez ; rien n'est présélectionné.</p>
      <form onSubmit={envoyer}>
        <div className="pb-cases">
          {f.cases.map((c) => (
            <label className="pb-case" key={c.code}>
              <input type="checkbox" checked={!!choix[c.code]} onChange={(e) => setChoix({ ...choix, [c.code]: e.target.checked })} />
              <span className="pb-case-texte">{c.texte}<span className="pb-case-sous">Valable {c.validite_mois} mois · retrait possible à tout moment</span></span>
            </label>
          ))}
        </div>
        {f.mention_generale && <div className="pb-mention">{f.mention_generale}</div>}
        {erreur && <div className="pb-erreur">{erreur}</div>}
        <button className="pb-btn" type="submit" disabled={envoi}>{envoi ? 'Enregistrement…' : 'Enregistrer mes choix'}</button>
      </form>
      <p className="pb-note">Ne rien cocher puis enregistrer vaut refus : nous n'insisterons pas. Responsable du traitement : {f.societe.raison_sociale}{f.societe.dpo_email ? ` · contact : ${f.societe.dpo_email}` : ''}{f.societe.politique_url ? <> · <a href={f.societe.politique_url} target="_blank" rel="noreferrer">politique de confidentialité</a></> : null}.</p>
    </Coquille>
  );
}
